import { useEffect, useState } from "react";

const navItems = [
  { label: "投稿通道", href: "#channels" },
  { label: "投稿流程", href: "#process" },
  { label: "在线投稿", href: "#submit" },
  { label: "热门分类", href: "#categories" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onLight = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        onLight
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[68px] w-full items-center justify-between px-4 md:h-[76px] md:px-8">
        <a href="#top" className="group flex items-center gap-2.5" aria-label="瓜田爆料 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-lg transition-colors ${
              onLight ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-water-flash-line" aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span
              className={`block font-heading text-base font-bold tracking-wide transition-colors md:text-lg ${
                onLight ? "text-foreground-950" : "text-background-50"
              }`}
            >
              瓜田爆料
            </span>
            <span
              className={`hidden text-[10px] font-label tracking-[0.22em] transition-colors md:block ${
                onLight ? "text-foreground-500" : "text-background-200"
              }`}
            >
              ANONYMOUS TIPS
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                onLight
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-background-100 hover:bg-background-50/10 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 focus:ring-offset-background-50 sm:inline-flex"
          >
            立即投稿
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 items-center justify-center rounded-md text-xl transition-colors lg:hidden ${
              onLight
                ? "text-foreground-800 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full flex-col px-4 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即投稿
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}